import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";

const useModelsPage = () => {
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const [models, setModels] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [genders, setGenders] = useState([]);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(12);
  // const [ageBand, setAgeBand] = useState("");
  const [gender, setGender] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  // const [imageFile, setImageFile] = useState(null);
  const [status, setStatus] = useState(false);
  const [galleryIds, setGalleryIds] = useState([]);
  const [pushLoader, setPushLoader] = useState(false);
  const [openPush, setOpenPush] = useState(false);
  const dispatch = useDispatch();

  // const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [openMessage, setOpenMessage] = useState("");
  const [pushStatus, setPushStatus] = useState("");

  const handleSelectImage = async (e, imageData) => {
    const isChecked = e.target.checked;
    const imageId = imageData.iModelId;

    if (isChecked) {
      setGalleryIds((prevSelected) => [...prevSelected, imageId]);
    } else {
      setGalleryIds((prevSelected) =>
        prevSelected.filter((id) => id !== imageId)
      );
    }
  };

  const handlePageClick = (number) => {
    setCurrentPage(number);
  };

  const fetchModels = async () => {
    try {
      setLoader(true);
      let url = `${
        endpoint.GET_MODELS
      }?iPageNumber=${currentPage}&iPageSize=${10}`;

      if (gender) {
        url += `&iGenderId=${gender}`;
      }

      // if (ageBand) {
      //   url += `&iAgeBandId=${ageBand}`;
      // }

      if (startDate) {
        url += `&dtStartDate=${startDate}`;
      }

      if (endDate) {
        url += `&dtEndDate=${endDate}`;
      }

      if (status) {
        url += `&bIsActive=${status === "active" ? 1 : 0}`;
      }

      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        dispatch,
        storeId,
      });
      if (response.data.status === "success") {
        setModels(response.data.data.modelData);
        if (genders.length <= 0 || bodyTypes.length <= 0) {
          setBodyTypes(response.data.data.filters.bodyTypeFilter);
          setGenders(response.data.data.filters.genderFilter);
        }
        setTotalCount(response.data.data.totalRecords);
      }
    } catch (error) {
      console.log("Error fetching images", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchModels();
  }, [currentPage, gender, startDate, endDate, status]);

  const handlePush = async () => {
    try {
      setPushLoader(true);
      const response = await apiHandler({
        url: endpoint.PUSH_MODELS,
        authToken: authData,
        method: "POST",
        data: {
          iModelId: galleryIds,
        },
        dispatch,
        storeId,
      });

      if (response.data.status === "success") {
        setOpenMessage(true);

        // toast.success(response.data.message);
        setPushStatus(response.data.message);
      } else {
        setOpenMessage(true);
        setPushStatus(response.data.message);
      }
      setGalleryIds([]);
    } catch (error) {
      console.log("Erorr pushing ", error);
    } finally {
      setPushLoader(false);
    }
  };

  return {
    models,
    loader,
    gender,
    setGender,
    genders,
    handlePageClick,
    totalCount,
    currentPage,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    status,
    setStatus,
    galleryIds,
    handleSelectImage,
    pushLoader,
    setOpenPush,
    openPush,
    setOpenMessage,
    openMessage,
    pushStatus,
    fetchModels,
    handlePush,
  };
};

export default useModelsPage;
